import { createTheme, useTheme } from '@mui/material/styles';
export function AppBarTextColor() {
    const theme = useTheme();
    const mainColor = theme.palette.secondary.dark 
    const color =  theme.palette.primary.dark

    return {'selectColor': color, 'mainColor':mainColor};
  }